<template>
  <div style="position:relative">

    <p>职能模块</p>
    <div class="categories">
      <el-tag v-for="item in companyCategories" :key="item._id" class="mr10 mb10 cate-item" size="small" :type="activeCategory._id === item._id && activeCategory.职能模块 === item.职能模块 ? '' : 'info'" @click="chooseCategory(item)">
        {{ item.职能模块 }}
      </el-tag>
    </div>
    <span class="title" style="margin-bottom:10px;display:block">职能模块认知：</span>
    <pre v-if="activeCategory.职能模块认知" class="company-pre" style="margin-bottom:10px">{{
      activeCategory.职能模块认知
    }}</pre>
    <p v-else class="empty-alert mb10">暂无职能模块认知，请尽快补充</p>

    <div style="padding-left:20px">
      <div class="edit-dialog-input-wrap">
        <el-input v-model="log" type="textarea" :autosize="{ minRows: 2 }"></el-input>
        <el-button size="mini" style="position:absolute;bottom:0;right:0" type="primary" class="custom-primary-plain" @click="saveLogFunc(log)">保存</el-button>
      </div>
      <div>
        <div
          v-for="item in showLogs"
          :key="item.createdAt"
          class="edit-dialog-single-p"
          style="flex-wrap:wrap"
        >
          <b style="font-weight:normal"
            >{{ dateFormat(item.createdAt) }} -- {{ item.account
            }}<span class="cate-tag">{{ activeCategory.职能模块 }}<i v-if="isAdmin || item.account===account" class="el-icon-delete ml10" style="flex:none;color:#de5c65;cursor:pointer;" @click="removeLog(item)"></i></span>
          </b>
          <div style="display:flex;width: 100%;align-items: flex-start;margin-top:10px;">
            <i class="el-icon-info mr10" style="flex:none"></i><span style="flex:auto;display: inline-block;white-space: pre-wrap;word-break: break-word;">{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    company: { type: Object, default: () => {} },
    item: Object,
  },
  data() {
    return {
      companyCategories: [],
      activeCategory: {},
      log: '',
      isAdmin: false,
      account:'',
    }
  },
  computed: {
    showLogs() {
      const logs = window._.cloneDeep(this.activeCategory.logs || [])
      logs.sort((a, b) => b.createdAt - a.createdAt)
      return logs
    },
  },
  mounted(){
    this.isAdmin = app.user.角色 && app.user.角色.includes('管理员')
    this.account = app.user.account
  },
  methods: {
    async initData() {
      this.companyCategories = []
      this.activeCategory = {}
      this.log = ''
      this.loadData()
    },
    async saveLogFunc(log) {
      if (!log) return this.$message.error('请填写要保存的内容')
      const savelog = {
        createdAt: new Date().getTime(),
        account: app.user.account,
        content: log,
      }
      const res = await app.service('company').comCateCognitionAddLog({
        id: this.activeCategory._id,
        log: savelog,
      })
      if (res.status === 'success') {
        this.loadData()
        this.log = ''
        this.$set(this.activeCategory,'logs',res.data)
      }
    },
    async removeLog(log){
      this.$confirm('确定要移除这条日志吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        const id = this.activeCategory._id
        const res = await app.service('company').comCateCognitionRemoveLog({
          id: id,
          log: log,
        })
        if (res.status === 'success') {
          this.$message.success('移除成功');
          const obj = this.companyCategories.find(v=>v._id===id)
          this.$set(obj,'logs',res.data)
        }else this.$message.error(res.msg)
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    chooseCategory(item){
      this.activeCategory = item
      this.log = ''
    },
    async loadData() {
      const res = await app.service('company').getComCateCognition(this.company._id)
      if (res.status === 'success') {
        res.data.forEach((element) => {
          if (element.logs && element.logs.length > 0) {
            element.logs.sort((a, b) => b.createdAt - a.createdAt)
          }
        })
        this.companyCategories = res.data
        if (this.item && this.item.category) {
          const act = res.data.find(a=>a.职能模块 && a.职能模块.toLowerCase().indexOf(this.item.category) != -1)
          if (act) return this.chooseCategory(act)
        }
        this.chooseCategory(this.companyCategories[0])
      } else {
        this.$message.error(res.msg)
      }
    },
    dateFormat(val, type) {
      return val ? dateFormat(val, type || 'yyyy-mm-dd') : ''
    },
  },
}
</script>
<style src="../../../../company/statistics/css/fullCompanyDetail.css" scoped></style>
<style src="../../../../company/statistics/css/commonCompany.css" scoped></style>
<style scoped>
.categories {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}
.cate-item {
  cursor: pointer;
}
.cate-delete-btn {
  margin-left: 5px;
  user-select: none;
}
.cate-tag {
  background-color: #eee;
  color: #afafaf;
  padding: 2px 10px;
  border-radius: 12px;
  margin-left: 6px;
  font-weight: normal;
}
.empty-alert {
  color: #cacaca;
  font-size: 16px;
}
.edit-dialog-input-wrap-border {
  border: 1px solid #eaeaea;
  width: 100%;
  padding: 10px;
  border-radius: 4px;
}
.company-pre {
  background-color: #fff;
}
</style>
